import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M14.618 11.023a1.226 1.226 0 0 0 0-2.046L8.9 5.205A1.225 1.225 0 0 0 7 6.227v7.546c0 .976 1.086 1.56 1.9 1.022z" />
  </svg>
);
export default SvgVideo;
